import { jsx, jsxs } from "react/jsx-runtime";
import { useMelwaysInfo } from "@seek/melways-react";
import { Box, Heading, Text, Inline, ButtonLink } from "braid-design-system";
import { useLink } from "../../../ApacCandidateFooter/components/Accordion/Accordion.mjs";
import { DropdownMenu } from "../../ApacCandidateHeader.mjs";
import { root } from "./AuthLinks.css.mjs";
const SkeletonLine = function({
  width,
  type,
  level,
  height,
  size
}) {
  const content = type === "heading" ? /* @__PURE__ */ jsx(Heading, { component: "span", level, children: " " }) : type === "text" && /* @__PURE__ */ jsx(Text, { size, children: " " }) || null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      display: "block",
      borderRadius: "standard",
      background: "neutralLight",
      height: type === "button" ? "touchable" : void 0,
      style: { width, ...height ? { height } : {} },
      children: content
    }
  );
};
const AuthLinks = ({ authItems, enableLoadingState }) => {
  const { locale } = useMelwaysInfo();
  const { sendLinkEvent, injectLinkContextToData } = useLink();
  if (!authItems) {
    return enableLoadingState ? /* @__PURE__ */ jsx(SkeletonLine, { type: "heading", width: 60, level: "4" }) : null;
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: root,
      height: "full",
      display: "flex",
      "data-automation": "sign-in-register",
      children: [
        authItems.objectType === "AuthNonMemberItem" && /* @__PURE__ */ jsx(Box, { height: "full", flexWrap: "nowrap", display: "flex", alignItems: "center", children: /* @__PURE__ */ jsx(Inline, { space: "small", children: authItems.child.map((item, index) => /* @__PURE__ */ jsx(
          ButtonLink,
          {
            variant: "ghost",
            tone: "formAccent",
            size: "small",
            href: item.href,
            onClick: () => {
              sendLinkEvent({
                linkContext: item.linkContext
              });
            },
            data: injectLinkContextToData(item.linkContext, {
              automation: item.linkContext.source
            }),
            title: item.text,
            rel: "nofollow",
            children: item.text
          },
          `buttonLink_${index}`
        )) }) }),
        authItems.objectType === "TabItemWithChild" && /* @__PURE__ */ jsx(
          DropdownMenu,
          {
            label: authItems.text,
            onExpendCollapseLinkContextData: authItems.linkContext,
            items: authItems.child,
            width: locale === "id-ID" ? "content" : "medium",
            shouldApplyIconForActiveItem: authItems.shouldApplyIconForActiveItem
          }
        )
      ]
    }
  );
};
export {
  AuthLinks
};
